
import TIM from "tim-js-sdk";
import { genTestUserSig } from "./../../../public/debug/GenerateTestUserSig";

class IMEvent {
    constructor({ EventList }) {
        EventList.map(todo => {
            if (!this[todo.name]) {
                console.error(`无☆☆${todo.name}☆☆监听事件`);
                return;
            }
        });
    }
}

class IM {
    roomId // IM群组名称 暂用课程id为群组名 必须为唯一
    sdkId // 腾讯云im sdkid
    Tim // 腾讯im实例
    userId // 当前用户名称
    userSig // 当前用户秘钥
    imEvent // im监听事件对象
    eventList = {} // im监听事件对象
    roomName // 房间名称
    constructor({ roomId, sdkId, name }) {
        this.roomId = String(roomId);
        this.sdkId = sdkId;
        this.roomName = name;
        this.init();
    }
    init() { // 创建腾讯云IM实例
        this.Tim = TIM.create({
            SDKAppID: this.sdkId
        });
    }
    readyEvent() { // 监听im状态
        return new Promise((resolve) => {
            this.Tim.on(TIM.EVENT.SDK_READY, () => {
                resolve(true);
            });
        });
    }
    login(userId) { // 登录IM
        this.userId = userId;
        this.userSig = genTestUserSig(userId).userSig;
        return new Promise((resolve) => {
            let data;
            this.readyEvent().then(() => {
                resolve(data);
            });
            this.Tim.login({
                userID: userId,
                userSig: this.userSig
            }).then(res => {
                data = res;
            });
        });
    }
    createRoom() { // 创建课堂房间
        return new Promise((resolve, reject) => {
            this.Tim.createGroup({
                type: TIM.TYPES.GRP_AVCHATROOM,
                groupID: this.roomId,
                name: this.roomName,
                joinOption: TIM.TYPES.JOIN_OPTIONS_FREE_ACCESS
            }).then(res => {
                this.joinRoom().then(data => resolve(data));
            }).catch(err => {
                if (err.code === 10021) { // 群组已创建 直接加入
                    this.joinRoom().then(data => resolve(data));
                    return;
                } else if (err.code === 10025) { // 群组已创建 并且当前用户为群主
                    this.joinRoom().then(data => resolve(data));
                } else { // 创建失败
                    reject(err);
                    console.error("创建课堂失败：", err);
                }
            });
        });
    }
    quitGroup() { // 退出群组
        this.Tim.quitGroup(this.roomId).then(res => {
            if (res.code) {
                console.log("退出房间失败：", res.code);
            } else {
                console.log("成功退出房间", res.code);
            }
            this.$router.go(-1);
        });
    }
    joinRoom() { // 加入房间
        return new Promise((resolve, reject) => {
            this.Tim.joinGroup({
                groupID: this.roomId,
                type: TIM.TYPES.GRP_AVCHATROOM
            }).then(res => {
                switch (res.data.status) {
                    case TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
                        resolve(res);
                        break;
                    case TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
                        resolve(res);
                        break;
                    default: // 其他情况一律判断为加群失败
                        reject(res);
                        break;
                }
            });
        });
    }
    dismissGroup() { // 解散群组
        return this.Tim.dismissGroup(this.roomId);
    }
    on(eventName, CallBack) { // 绑定监听事件
        this.eventList[eventName] = CallBack;
        this.Tim.on(eventName, this.eventList[eventName]);
    }
    logout() { // 退出登录
        for (const eventName in this.eventList) {
            this.Tim.off(eventName, this.eventList[eventName]);
        }
        return this.Tim.logout();
    }
    sendGroupTextMessage({ to, text }) { // 发送消息
        console.error("发送消息：", to, text);
        const message = this.Tim.createTextMessage({
            to: to || this.roomId,
            conversationType: TIM.TYPES.CONV_GROUP,
            payload: {
                text
            }
        });
        return this.Tim.sendMessage(message);
    }
    addEventList(EventList, CallBack) { // 绑定监听事件
        this.imEvent = new IMEvent({ EventList });
        return this.imEvent;
    }
}
export default IM;
